import React from "react";
import { FaFacebookF, FaInstagram, FaGoogle } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import "./Footer.css";
import { useTranslation } from "react-i18next";

const Footer2 = () => {
  const { t } = useTranslation();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="footer-dark" id="footerxx">
        <footer>
          <div className="container">
            <hr></hr>
            <Row>
              <Col xs="12" md="3" className="footer-column">
                <h3 id="titlefooter"> {t("ftitle1")}</h3>
                <ul>
                  <Link to="/menu">
                    {" "}
                    <li>{t("fp1")}</li>
                  </Link>
                  <Link to="/menu">
                    {" "}
                    <li>{t("fp2")}</li>
                  </Link>

                  <Link to="/appartament">
                    {" "}
                    <li>{t("fp3")}</li>{" "}
                  </Link>
                </ul>
              </Col>
              <Col xs="12" md="5" className="footer-column">
                <h3 id="titlefooter">{t("ftitle2")}</h3>
                <ul>
                  <li>
                    <a href="mailto:cubedducri78@gmail.com">cubedducri78@gmail.com</a>
                  </li>
                  <li>
                    <a href="tel:0782 623533">0782 623533</a>
                  </li>
                  <li>
                    <a href="https://maps.app.goo.gl/qnhiWkGbMd2zWjVm9">Via Piemonte, 25, 08048 Tortolì (NU)</a>
                  </li>
                </ul>
              </Col>
              <Col xs="12" md="4" className="footer-column">
                <h3 id="titlefooter">{t("ftitle3")}</h3>
                <ul>
                  <li>
                    <a href="mailto:cameredaangelo@outlook.com">cameredaangelo@outlook.com</a>
                  </li>
                  <li>
                    <a href="tel:3288351018">+39 3288351018</a>
                  </li>
                  <li>
                    <a href="https://maps.app.goo.gl/qnhiWkGbMd2zWjVm9">Via Piemonte, 25, 08048 Tortolì (NU)</a>
                  </li>
                </ul>
              </Col>
            </Row>
            <hr />
            <div className="social">
              <a
                href="https://www.facebook.com/p/Trattoria-da-Angelo-100066632286310/?locale=it_IT"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF />
              </a>
              <a href="https://www.instagram.com/trattoria.da.angelo/" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
              <a href="https://maps.app.goo.gl/qnhiWkGbMd2zWjVm9" target="_blank" rel="noopener noreferrer">
                <FaGoogle />
              </a>
            </div>
          </div>
          <div className="admin mb-4">
            <Link to="/login" className="foot" onClick={scrollToTop}>
              <img
                width="50"
                height="50"
                src="https://img.icons8.com/ios-filled/50/FFFFFF/admin-settings-male.png"
                alt="admin-settings-male"
                className="mb-2"
              />
            </Link>
          </div>
          <br></br>
          <br></br>

          <a href="https://marcopala-portfolio.web.app/">
            {" "}
            <img src="./img/immagini/white.png" alt="" style={{ width: "170px" }} id="logomio" />
          </a>
        </footer>
      </div>
    </>
  );
};

export default Footer2;
